/* The Rugs :: blog category pages. Save-for-later hearts share the article reading list. */
(function () {
  var root = document.querySelector('[data-bg-root]');
  if (!root) return;
  var KEY = 'therugs:saved-guides';
  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  var counter = root.querySelector('[data-bg-saved-count]');
  function paintCount() { if (counter) counter.textContent = String(read().length); }
  Array.prototype.forEach.call(root.querySelectorAll('[data-bg-save]'), function (b) {
    var h = b.getAttribute('data-bg-save');
    var on = read().indexOf(h) > -1;
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.textContent = on ? '\u2665' : '\u2661';
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var list = read(); var at = list.indexOf(h);
      if (at > -1) list.splice(at, 1); else list.push(h);
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (err) {}
      var now = at === -1;
      b.setAttribute('aria-pressed', now ? 'true' : 'false');
      b.textContent = now ? '\u2665' : '\u2661';
      paintCount();
    });
  });
  paintCount();
})();
